/*
  Glossary pop-ups (snippets/nr-glossary-term.liquid). Each dotted word is a
  real link to /pages/glossary#term; here a tap, a click or keyboard focus
  shows its definition in a small pop-up instead, so the reader stays on the
  page. On a computer it also opens on hover. On phones it's a sheet at the
  bottom of the screen. Guides' evidence labels (span.nr-evidence--*) open
  the "Evidence ratings" definition the same way when the page has it.
  Opens are published as nr_glossary_open.
*/
(function () {
  if (window.nrGlossaryPop) return;
  window.nrGlossaryPop = true;

  var pop, popName, popText, current, hideTimer;
  var openedAt = 0;
  var hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var phone = window.matchMedia('(max-width: 749px)');

  function build() {
    pop = document.createElement('div');
    pop.className = 'nr-term-pop';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-modal', 'false');
    pop.hidden = true;
    pop.innerHTML =
      '<p class="nr-term-pop__name"></p><p class="nr-term-pop__text"></p>' +
      '<button type="button" class="nr-term-pop__close" aria-label="Close">&times;</button>';
    popName = pop.querySelector('.nr-term-pop__name');
    popText = pop.querySelector('.nr-term-pop__text');
    pop.querySelector('.nr-term-pop__close').addEventListener('click', close);
    pop.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    pop.addEventListener('mouseleave', laterClose);
    document.body.appendChild(pop);
  }

  function definitionFor(trigger) {
    var id = trigger.getAttribute('aria-describedby');
    if (!id && trigger.matches('[class*="nr-evidence--"]')) id = 'nr-term-evidence-ratings';
    return id ? document.getElementById(id) : null;
  }

  function place(trigger) {
    if (phone.matches) {
      pop.style.left = pop.style.top = '';
      return;
    }
    var r = trigger.getBoundingClientRect();
    var width = pop.offsetWidth;
    var left = Math.min(Math.max(12, r.left + r.width / 2 - width / 2), window.innerWidth - width - 12);
    var top = r.bottom + 8;
    if (top + pop.offsetHeight > window.innerHeight - 12) top = r.top - pop.offsetHeight - 8;
    pop.style.left = left + window.scrollX + 'px';
    pop.style.top = top + window.scrollY + 'px';
  }

  function open(trigger) {
    var def = definitionFor(trigger);
    if (!def) return false;
    if (!pop) build();
    clearTimeout(hideTimer);
    if (current && current !== trigger) current.setAttribute('aria-expanded', 'false');
    current = trigger;
    popName.textContent = def.dataset.name || '';
    popText.textContent = def.textContent;
    pop.classList.toggle('nr-term-pop--sheet', phone.matches);
    pop.hidden = false;
    place(trigger);
    trigger.setAttribute('aria-expanded', 'true');
    openedAt = Date.now();
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      Shopify.analytics.publish('nr_glossary_open', { term: def.id.replace('nr-term-', ''), page: location.pathname });
    }
    return true;
  }

  function close() {
    if (!pop || pop.hidden) return;
    pop.hidden = true;
    if (current) current.setAttribute('aria-expanded', 'false');
    current = null;
  }

  function laterClose() {
    if (!hover.matches) return;
    clearTimeout(hideTimer);
    hideTimer = setTimeout(close, 250);
  }

  function triggerFrom(target) {
    return target.closest && target.closest('.nr-term, [class*="nr-evidence--"]');
  }

  document.addEventListener('click', function (event) {
    var trigger = triggerFrom(event.target);
    if (trigger) {
      // A second tap on the same word closes it (but not the tap that just
      // opened it through focus).
      if (current === trigger && pop && !pop.hidden && !hover.matches && Date.now() - openedAt > 400) {
        event.preventDefault();
        close();
        return;
      }
      if (current === trigger && pop && !pop.hidden) {
        event.preventDefault();
        return;
      }
      if (open(trigger)) event.preventDefault();
      return;
    }
    if (pop && !pop.contains(event.target)) close();
  });

  document.addEventListener('mouseover', function (event) {
    if (!hover.matches) return;
    var trigger = triggerFrom(event.target);
    if (trigger) open(trigger);
  });

  document.addEventListener('mouseout', function (event) {
    if (triggerFrom(event.target)) laterClose();
  });

  document.addEventListener('focusin', function (event) {
    var trigger = triggerFrom(event.target);
    if (trigger) open(trigger);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && current) {
      var trigger = current;
      close();
      trigger.focus();
    }
  });

  window.addEventListener('resize', close);

  // Evidence labels aren't links, so make them reachable by keyboard.
  document.querySelectorAll('[class*="nr-evidence--"]').forEach(function (label) {
    if (!document.getElementById('nr-term-evidence-ratings')) return;
    label.setAttribute('tabindex', '0');
    label.setAttribute('role', 'button');
    label.setAttribute('aria-describedby', 'nr-term-evidence-ratings');
    label.classList.add('nr-term--label');
  });
})();
